import { render, staticRenderFns } from "./batch-search.vue?vue&type=template&id=6dfb7b8f&scoped=true&"
import script from "./batch-search.vue?vue&type=script&lang=js&"
export * from "./batch-search.vue?vue&type=script&lang=js&"
import style0 from "./batch-search.vue?vue&type=style&index=0&id=6dfb7b8f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb7b8f",
  null
  
)

export default component.exports